import React from "react";
import SideBySideSectionCard from "../SideBySideSectionCard/SideBySideSectionCard";

function ExercerSeusDireitosEParaOutrasPessoas() {
  const subtext1 = (
    <p>
      Se for exercer um direito seu, é importante que, além de informar seus
      dados pessoais, você também nos envie alguns documentos necessários, por
      foto ou digitalizados. Esses dados e documentos nos auxiliam no processo 
      de autenticação, evitando possíveis fraudes e o acesso indevido às suas informações.
    </p>
  );
  const subtext2 = (
    <>
      <li>
        {" "}
        <b>Documento de identificação com foto</b> (CNH, RG, passaporte,
        carteira identidade profissional ou carteira de trabalho).
      </li>
      <br />
      <li>
        <b>Comprovante de residência</b> (conta de água, luz, internet ou
        telefone) – caso você não tenha um comprovante de residência em seu
        nome, inclua o comprovante disponível e justifique no campo a seguir o
        motivo de o documento não estar em seu nome.
      </li>
      <br />
      <li>
        <b>Para realizar a solicitação</b>, encaminhar documentação solicitada
        por e-mail para dpo@caixaconsorcio.com.br
      </li>
    </>
  );

  const subtext4 = (
    <p>
      Se for solicitar um <b>direito em nome de outra pessoa</b>, é importante
      que, além de informar os seus dados pessoais e o da pessoa, você também
      nos envie alguns documentos necessários, por foto ou digitalizados.
    </p>
  );

  const subtext5 = (
    <>
      <b>De quem solicita:</b>
      <br />
      <br />
      <li>
        {" "}
        <b>Documento de identificação com foto</b> (CNH, RG, passaporte,
        carteira identidade profissional ou carteira de trabalho).
      </li>
      <br />
      <li>
        <b>Comprovante de residência</b> (conta de água, luz, internet ou
        telefone) – caso você não tenha um comprovante de residência em seu
        nome, inclua o comprovante disponível e justifique no campo a seguir o
        motivo de o documento não estar em seu nome.
      </li>
      <br />
    </>
  );

  const subtext6 = (
    <>
      <b>Da outra pessoa:</b>
      <br />
      <br />
      <li>
        <b>Documento de identificação com foto</b> (CNH, RG, carteira de
        identidade profissional, passaporte ou carteira de trabalho).
      </li>
      <br />
      <li>
        <b>Procuração ou outro documento oficial </b> que comprove que você é o
        responsável por essa outra pessoa.
      </li>
      <br />
      <li>
        Para realizar a solicitação, <b>encaminhar</b> documentação solicitada
        por e-mail para dpo@caixaconsorcio.com.br
      </li>
      <br></br>
    </>
  );

  return (
    <div>
      <SideBySideSectionCard
        id="ParaExercerSeusDireitos"
        title="Para exercer seus direitos"
        subtext1={subtext1}
        subtext2={subtext2}
        title2="Para exercer direitos para outra pessoa"
        subtext4={subtext4}
        subtext5={subtext5}
        subtext6={subtext6}
      />
    </div>
  );
}

export default ExercerSeusDireitosEParaOutrasPessoas;
